export const ROW_HOVER_CLASS_NAME = "ant-table-row-hover";
